import { Row, Col, Form } from "react-bootstrap";
import { useEffect } from "react";
import CustomAutoCompleteCartaPorte from "../../../../components/formik/CustomAutoCompleteCartaPorte";

const MercanciasFormFields = ({ formik, order, findClaveProdServCP }) => {
  const { values, errors, touched, setFieldValue, handleChange } = formik;

  // Calcular los datos de Mercancias basados en los vehículos
  useEffect(() => {
    const initMercancias = async () => {
      if (order?.Vehicles?.length > 0) {
        const mercancias = [];

        for (const veh of order.Vehicles) {
          //const peso = veh.carga_kg || 0;
          const peso = 0;
          // Buscar clave de producto/servicio
          const claves = await findClaveProdServCP("25101503");

          mercancias.push({
            BienesTransp: claves.length
              ? {
                  ...claves[0],
                  palabraSimilar:
                    claves[0].palabraSimilar || claves[0].descripcion,
                }
              : null,
            Descripcion: `${
              veh.VehicleModel?.VehicleType?.vehicle_type_name || ""
            } ${veh.VehicleModel?.Brand?.brand_name || ""} ${
              veh.VehicleModel?.model_name || ""
            }`,
            Cantidad: "1.0",
            ClaveUnidad: "KGM",
            PesoEnKg: peso.toString(),
            CantidadTransporta: [
              {
                Cantidad: "1",
                IDOrigen: "OR000001",
                IDDestino: "DE000001",
              },
            ],
          });
        }

        const pesoBrutoTotal = mercancias.reduce(
          (acc, m) => acc + parseFloat(m.PesoEnKg || 0),
          0
        );

        setFieldValue("mercancias", {
          PesoBrutoTotal: pesoBrutoTotal.toString(),
          UnidadPeso: "KGM",
          NumTotalMercancias: mercancias.length.toString(),
          Mercancia: mercancias,
        });
      }
    };

    initMercancias();
  }, [order, setFieldValue]);

  useEffect(() => {
    if (values.mercancias?.Mercancia?.length > 0) {
      const totalMercancias = values.mercancias.Mercancia.reduce(
        (acc, m) => acc + parseFloat(m.Cantidad || 0),
        0
      );

      const pesoBrutoTotal = values.mercancias.Mercancia.reduce(
        (acc, m) =>
          acc + parseFloat(m.Cantidad || 0) * parseFloat(m.PesoEnKg || 0),
        0
      );

      setFieldValue(
        "mercancias.NumTotalMercancias",
        totalMercancias.toString()
      );
      setFieldValue("mercancias.PesoBrutoTotal", pesoBrutoTotal.toString());
    }
  }, [values.mercancias?.Mercancia, setFieldValue]);

  return (
    <>
      {values.mercancias?.Mercancia?.map((merc, idx) => (
        <div
          key={idx}
          className="mb-4 p-3 rounded shadow"
          style={{
            backgroundColor: "#f8f9fa",
          }}
        >
          <Row className="mb-3">
            {/* AUTOCOMPLETE para BienesTransp */}
            <Form.Group
              as={Col}
              md="6"
              controlId={`mercancias.Mercancia[${idx}].BienesTransp`}
            >
              <CustomAutoCompleteCartaPorte
                formik={formik}
                field={`mercancias.Mercancia[${idx}].BienesTransp`}
                label="Bienes Transportados"
                searchFunction={findClaveProdServCP}
                descriptionField="palabraSimilar"
                idDisplayFormatter={(id, item) =>
                  `${item.id} - ${item.descripcion} `
                }
                useFormikPath
              />
              {touched.mercancias?.Mercancia?.[idx]?.BienesTransp &&
                errors.mercancias?.Mercancia?.[idx]?.BienesTransp && (
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: "block" }}
                  >
                    {errors.mercancias.Mercancia[idx].BienesTransp}
                  </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md="6">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name={`mercancias.Mercancia[${idx}].Descripcion`}
                value={merc.Descripcion}
                onChange={handleChange}
                isInvalid={
                  touched.mercancias?.Mercancia?.[idx]?.Descripcion &&
                  !!errors.mercancias?.Mercancia?.[idx]?.Descripcion
                }
              />
              <Form.Control.Feedback type="invalid">
                {errors.mercancias?.Mercancia?.[idx]?.Descripcion}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="4">
              <Form.Label>Cantidad</Form.Label>
              <Form.Control
                type="number"
                name={`mercancias.Mercancia[${idx}].Cantidad`}
                value={merc.Cantidad}
                onChange={handleChange}
                isInvalid={
                  touched.mercancias?.Mercancia?.[idx]?.Cantidad &&
                  !!errors.mercancias?.Mercancia?.[idx]?.Cantidad
                }
                min="0"
                step="0.01"
                disabled={true}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mercancias?.Mercancia?.[idx]?.Cantidad}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4">
              <Form.Label>Peso (Kg)</Form.Label>
              <Form.Control
                type="number"
                name={`mercancias.Mercancia[${idx}].PesoEnKg`}
                value={merc.PesoEnKg}
                onChange={handleChange}
                isInvalid={
                  touched.mercancias?.Mercancia?.[idx]?.PesoEnKg &&
                  !!errors.mercancias?.Mercancia?.[idx]?.PesoEnKg
                }
                min="0"
                step="0.01"
              />
              <Form.Control.Feedback type="invalid">
                {errors.mercancias?.Mercancia?.[idx]?.PesoEnKg}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4">
              <Form.Label>Unidad</Form.Label>
              <Form.Control
                type="text"
                name={`mercancias.Mercancia[${idx}].ClaveUnidad`}
                value={merc.ClaveUnidad}
                onChange={handleChange}
                disabled
                readOnly
              />
            </Form.Group>
          </Row>

          {merc.CantidadTransporta?.map((ct, tIdx) => (
            <Row className="mb-3" key={tIdx}>
              <Form.Group as={Col} md="4">
                <Form.Label>Cantidad Transporta</Form.Label>
                <Form.Control
                  type="text"
                  name={`mercancias.Mercancia[${idx}].CantidadTransporta[${tIdx}].Cantidad`}
                  value={ct.Cantidad}
                  onChange={handleChange}
                  disabled
                  readOnly
                />
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label>ID Origen</Form.Label>
                <Form.Control
                  type="text"
                  name={`mercancias.Mercancia[${idx}].CantidadTransporta[${tIdx}].IDOrigen`}
                  value={ct.IDOrigen}
                  onChange={handleChange}
                  isInvalid={
                    touched.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDOrigen &&
                    !!errors.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDOrigen
                  }
                  disabled={true}
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDOrigen
                  }
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label>ID Destino</Form.Label>
                <Form.Control
                  type="text"
                  name={`mercancias.Mercancia[${idx}].CantidadTransporta[${tIdx}].IDDestino`}
                  value={ct.IDDestino}
                  onChange={handleChange}
                  isInvalid={
                    touched.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDDestino &&
                    !!errors.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDDestino
                  }
                  disabled={true}
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors.mercancias?.Mercancia?.[idx]?.CantidadTransporta?.[
                      tIdx
                    ]?.IDDestino
                  }
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          ))}
        </div>
      ))}

      <Row className="mt-3">
        <Form.Group as={Col} md="4">
          <Form.Label>Peso Bruto Total</Form.Label>
          <Form.Control
            type="text"
            name="mercancias.PesoBrutoTotal"
            value={values.mercancias?.PesoBrutoTotal || ""}
            onChange={handleChange}
            disabled
            readOnly
          />
        </Form.Group>

        <Form.Group as={Col} md="4">
          <Form.Label>Total de Mercancías</Form.Label>
          <Form.Control
            type="text"
            name="mercancias.NumTotalMercancias"
            value={values.mercancias?.NumTotalMercancias || ""}
            onChange={handleChange}
            disabled
            readOnly
          />
        </Form.Group>

        <Form.Group as={Col} md="4">
          <Form.Label>Unidad de Peso</Form.Label>
          <Form.Control
            type="text"
            name="mercancias.UnidadPeso"
            value={values.mercancias?.UnidadPeso || ""}
            onChange={handleChange}
            disabled
            readOnly
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default MercanciasFormFields;
